















































































import { Vue, Component } from 'vue-property-decorator';
import Music from '../components/Music.vue';
import { Popup } from 'vant';
Vue.use(Popup);
@Component({
  components: {
    Music,
  },
})
export default class Welcome extends Vue {
  show: boolean = false;
  showTab: boolean = false;
  home1 = false;
  home2 = false;
  home3 = true;
  mounted() {
    this.show = true;
    this.home3 = !this.home3;
    this.slide();
    setTimeout(() => {
      this.home1 = true;
    }, 500);
    setTimeout(() => {
      this.home2 = true;
    }, 1000);
  }
  slide() {
    setInterval(() => {
      this.home3 = !this.home3;
    }, 500);
  }
  toggleModal() {
    this.show = false;
  }
  // showPopup() {
  //   this.show = true;
  // }
}
